const baseApiPath = 'companies/:companyId/xero/counterparties/payment-details';

export const paymentDetailsApiPaths = {
    requirements: `${baseApiPath}/requirements`,
} as const;
